import {Button, Space} from "antd";
import type {GetSubscriptionApiResponse} from "../../../../react-query-hooks/store/subscriptions/get-subscription/types";
import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {
  handleFacebookLink,
  handleMailLink,
  handleSubscriptionLink,
  handleTwitterLink,
} from "../../../../utils/products";
import {REBRAND_BASE_URL} from "../../../../services/config";
import {ProfileWidgetSkeleton} from "../../../calls/upcoming-calls/profile-widget/profile-widget-skeleton";
import {StyledShareServiceWidgetWrapper} from "../../../calls/service/share-service-widget/share-service-widget.style";
import {ShareOfferingWidget} from "../../../public-profile/offering/share-offering";

type ShareSubscriptionWidgetProps = {
  subscriptionData: GetSubscriptionApiResponse;
  isFetching: boolean;
};

export function ShareSubscriptionWidget({
  subscriptionData,
  isFetching,
}: ShareSubscriptionWidgetProps) {
  const {state: profileState} = useGetProfileContext();
  const sub = subscriptionData.productSubscription;

  const extraParams = {
    facebookLink: handleFacebookLink({
      username: profileState.profileData.username,
    }),
    twitterLink: handleTwitterLink({
      textContent: `I created a subscription titled ${sub.name} on Coachli!`,
      username: profileState.profileData.username,
    }),
    mailLink: handleMailLink({
      body: `Check out my subscription on Coachli! ${REBRAND_BASE_URL}/${profileState.profileData.username}`,
      subject: "",
    }),
    copyLink: handleSubscriptionLink({
      subscriptionId: sub.id,
      slug: sub.slug,
      username: profileState.profileData.username,
      tinyUrl: sub.tiny_url ?? "",
      windowNav: true,
    }),
  };

  const productDescription = sub.description.replace(/<[^>]+>/g, "");

  const viewLink = handleSubscriptionLink({
    subscriptionId: sub.id,
    slug: sub.slug,
    username: profileState.profileData.username,
    tinyUrl: sub.tiny_url ?? "",
    windowNav: true,
  });

  return (
    <StyledShareServiceWidgetWrapper>
      {isFetching ? (
        <ProfileWidgetSkeleton />
      ) : (
        <>
          <h2 className="profile-widget-heading">Share subscription link</h2>
          <div className="profile-widget-card">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <div className="profile-widget-card-header">
                <h3 className="profile-widget-card-user-name">{sub.name}</h3>
              </div>
              <p className="profile-widget-card-bio">{productDescription}</p>
              <div>
                <Button
                  size="small"
                  block
                  htmlType="button"
                  target="_blank"
                  href={viewLink}
                >
                  View subscription page
                </Button>
              </div>
              <ShareOfferingWidget
                title="Share subscription via"
                extraParams={extraParams}
              />
            </Space>
          </div>
        </>
      )}
    </StyledShareServiceWidgetWrapper>
  );
}
